import { useNavigate } from 'react-router-dom';
import { AbsoluteCenter } from '@chakra-ui/react';
import { t } from 'i18next';
import { Xmark } from '@peacecover/icon';
import StickyHeader from '../../components/StickyHeader';
import RegularSolidButton from '../../components/buttons/RegularSolidButton';

const FanBuddyIntroPage = () => {
  const navigate = useNavigate();
  const onClickStart = () => {
    navigate('/fan-buddy/chat-bot-splash');
  };

  const exit = () => {
    navigate(-1);
  };

  return (
    <>
      <StickyHeader
        title={t('FanBuddyIntroPage.pageTitle') as string}
        alwaysShowTitle={false}
        showBackButton={false}
        leftContent={<Xmark size={24} className="text-text-main-lv1" onClick={exit} />}
        showTitle={true}
      />
      <AbsoluteCenter style={{ padding: '0 24px', width: '100%' }}>
        <div className="flex flex-col items-center">
          <h1 className="text-[26px] font-bold leading-[31px] text-center text-text-main-lv1">
            {t('FanBuddyIntroPage.title')}
          </h1>
          <p className="text-[15px] font-medium leading-[18px] text-center text-text-main-lv4 pt-[14px]">
            {t('FanBuddyIntroPage.description')}
          </p>
        </div>
        <div className="flex flex-col items-center">
          <img
            width={'172px'}
            height={'172px'}
            src={'/assets/backgrounds/fan-buddy/Maracas.png'}
            alt={''}
            style={{ paddingTop: '42px' }}
          />
          <RegularSolidButton
            text={t('FanBuddyIntroPage.startButton')}
            style={{
              fontSize: '17px',
              borderRadius: '8px',
              marginTop: '107px',
              padding: '16px 0',
              lineHeight: '20px',
              fontWeight: 500,
              width: '100%'
            }}
            onClicked={onClickStart}
          />
        </div>
        {/* <AgreementDescription>
        {"시작하기를 누르면 정보저장에 동의합니다"}
      </AgreementDescription> */}
      </AbsoluteCenter>
    </>
  );
};

export default FanBuddyIntroPage;
